import { PayloadAction } from '@reduxjs/toolkit';

import { DesignState } from 'editor/src/store/design/types';

const setGlobalPluginReducer = (state: DesignState, action: PayloadAction<string[]>) => {
  state.globalPlugins = action.payload;
};

export default setGlobalPluginReducer;
